import { render, staticRenderFns } from "./TreasuryAccount.vue?vue&type=template&id=314b2e75&"
import script from "./TreasuryAccount.vue?vue&type=script&lang=js&"
export * from "./TreasuryAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports